export default "__VITE_ASSET__dc28ce14__"